import type { RouteRecordRaw } from 'vue-router'
import { HelmPermission } from '@helm/services/api/client'

const messaging: readonly RouteRecordRaw[] = [
    {
        path: `/messaging`,
        component: () => import('@helm/pages/Messaging/MessagingMetrics.vue'),
        name: `messaging`,
        meta: {
            props: {
                sideNav: `messaging`
            }
        }
    },
    {
        path: `/messaging/public-templates`,
        component: () => import('@helm/pages/Messaging/PublicMessageTemplates.vue'),
        name: `public-templates`,
        meta: {
            props: {
                sideNav: `messaging`
            }
        }
    },
    {
        path: `/messaging/global-templates`,
        component: () => import('@helm/pages/Messaging/GlobalMessageTemplates.vue'),
        name: `global-templates`,
        meta: {
            props: {
                sideNav: `messaging`
            }
        }
    },
    {
        path: `/messaging/email-suppressions`,
        component: () => import('@helm/pages/Messaging/EmailSuppressions.vue'),
        name: `messaging.email-suppressions`,
        meta: {
            props: {
                sideNav: `messaging`
            },
            roles: [HelmPermission.HELM_EMAIL_SUPPRESSION_READ, HelmPermission.HELM_EMAIL_SUPPRESSION_WRITE]
        }
    },
    {
        path: `/messaging/sms-blacklist`,
        component: () => import('@helm/pages/Messaging/SmsBlacklist.vue'),
        name: `messaging.sms-blacklist`,
        meta: {
            props: {
                sideNav: `messaging`
            },
            roles: [HelmPermission.HELM_SMS_BLACKLIST_READ, HelmPermission.HELM_SMS_BLACKLIST_WRITE]
        }
    }
]

export default messaging
